import {
  LIST_ADMISSION_REQUEST,
  LIST_ADMISSION_SUCCESS,
  LIST_ADMISSION_FAIL,
  LIST_ADMISSION_REGISTRATION_REQUEST,
  LIST_ADMISSION_REGISTRATION_SUCCESS,
  LIST_ADMISSION_REGISTRATION_FAIL,
  LIST_ADMISSION_RSVP_LIST_REQUEST,
  LIST_ADMISSION_RSVP_LIST_SUCCESS,
  LIST_ADMISSION_RSVP_LIST_FAIL,
  LIST_ADMISSION_RSVP_LIST_RESET,
  LIST_ADMISSION_PACKAGE_REQUEST,
  LIST_ADMISSION_PACKAGE_SUCCESS,
  LIST_ADMISSION_PACKAGE_FAIL,
  DETAIL_ADMISSION_RSVP_REQUEST,
  DETAIL_ADMISSION_RSVP_SUCCESS,
  DETAIL_ADMISSION_RSVP_FAIL,
  DETAIL_ADMISSION_MR_REQUEST,
  DETAIL_ADMISSION_MR_SUCCESS,
  DETAIL_ADMISSION_MR_FAIL,
  DETAIL_PROJECT_BY_PACKAGE_REQUEST,
  DETAIL_PROJECT_BY_PACKAGE_SUCCESS,
  DETAIL_PROJECT_BY_PACKAGE_FAIL,
  CREATE_ADMISSION_REQUEST,
  CREATE_ADMISSION_SUCCESS,
  CREATE_ADMISSION_FAIL,
  DETAIL_ADMISSION_REQUEST,
  DETAIL_ADMISSION_SUCCESS,
  DETAIL_ADMISSION_FAIL,
  UPDATE_ADMISSION_REQUEST,
  UPDATE_ADMISSION_SUCCESS,
  UPDATE_ADMISSION_FAIL,
  DELETE_ADMISSION_REQUEST,
  DELETE_ADMISSION_SUCCESS,
  DELETE_ADMISSION_FAIL,
  RESET_ADMISSION_FORM,
  LIST_ADMISSION_ADDITIONAL_INFO_REQUEST,
  LIST_ADMISSION_ADDITIONAL_INFO_SUCCESS,
  LIST_ADMISSION_ADDITIONAL_INFO_FAIL,
  DETAIL_PRINT_INVOICE_PATIENT_REQUEST,
  DETAIL_PRINT_INVOICE_PATIENT_SUCCESS,
  DETAIL_PRINT_INVOICE_PATIENT_FAIL,
  LOG_HISTORY_ADMISSION_REQUEST,
  LOG_HISTORY_ADMISSION_SUCCESS,
  LOG_HISTORY_ADMISSION_FAIL,
  LIST_PRINT_HISTORY_RESULT_REQUEST,
  LIST_PRINT_HISTORY_RESULT_SUCCESS,
  LIST_PRINT_HISTORY_RESULT_FAIL,
  PRINT_HISTORY_RESULT_REQUEST,
  PRINT_HISTORY_RESULT_SUCCESS,
  PRINT_HISTORY_RESULT_FAIL,
  IMPORT_ADMISSION_DATA_REQUEST,
  IMPORT_ADMISSION_DATA_SUCCESS,
  IMPORT_ADMISSION_DATA_FAIL,
  LIST_IMPORT_ADMISSION_DATA_REQUEST,
  LIST_IMPORT_ADMISSION_DATA_SUCCESS,
  LIST_IMPORT_ADMISSION_DATA_FAIL,
  LIST_DETAIL_IMPORT_DATA_ADMISSION_REQUEST,
  LIST_DETAIL_IMPORT_DATA_ADMISSION_SUCCESS,
  LIST_DETAIL_IMPORT_DATA_ADMISSION_FAIL,
  EXPORT_IMPORT_DATA_ADMISSION_REQUEST,
  EXPORT_IMPORT_DATA_ADMISSION_SUCCESS,
  EXPORT_IMPORT_DATA_ADMISSION_FAIL,
  DETAIL_IMPORT_DATA_ADMISSION_REQUEST,
  DETAIL_IMPORT_DATA_ADMISSION_SUCCESS,
  DETAIL_IMPORT_DATA_ADMISSION_FAIL,
  RESET_DETAIL_PROJECT_BY_PACKAGE,
  MEDICAL_INFO_SUMMARY_REQUEST,
  MEDICAL_INFO_SUMMARY_SUCCESS,
  MEDICAL_INFO_SUMMARY_FAIL,
  MEDICAL_INFO_SUMMARY_OPTIONAL_REQUEST,
  MEDICAL_INFO_SUMMARY_OPTIONAL_SUCCESS,
  MEDICAL_INFO_SUMMARY_OPTIONAL_FAIL,
  GET_BRANCH_MAX_CAPACITY_REQUEST,
  GET_BRANCH_MAX_CAPACITY_SUCCESS,
  GET_BRANCH_MAX_CAPACITY_FAIL,
  LIST_ADMISSION_MS_PACKAGE_REQUEST,
  LIST_ADMISSION_MS_PACKAGE_SUCCESS,
  LIST_ADMISSION_MS_PACKAGE_FAIL,
  LIST_ADMISSION_MS_SERVICE_REQUEST,
  LIST_ADMISSION_MS_SERVICE_SUCCESS,
  LIST_ADMISSION_MS_SERVICE_FAIL,
  LIST_ADMISSION_ONLINE_RSVP_REQUEST,
  LIST_ADMISSION_ONLINE_RSVP_SUCCESS,
  LIST_ADMISSION_ONLINE_RSVP_FAIL,
  GET_SUMMARY_RSVP_VISIT_TIME_REQUEST,
  GET_SUMMARY_RSVP_VISIT_TIME_SUCCESS,
  GET_SUMMARY_RSVP_VISIT_TIME_FAIL
} from '../../constants/admission'

const initialState = {
  admissionList: [],
  registrationList: [],
  admission: {},
  additionalInfo: [],
  medicalInfoSummary: [],
  medicalInfoOptionSummary: [],
  detailPrintInvoice: {},
  rsvpList: [],
  rsvp: {},
  mrNumberList: [],
  mrNumber: {},
  projectPackage: {},
  packageList: [],
  msPackageList: [],
  msServiceList: [],
  historyResults: [],
  loadingHisotryResult: false,
  loadingPrintHistoryResult: false,
  importAdmissionData: {},
  importAdmissionDataList: [],
  detailImportAdmissionDataList: [],
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  loadingImport: false,
  loading: false,
  loadingExport: false,
  loadingAdditionalInfo: false,
  loadingMedicalInfo: false,
  error: null,
  pageable: {},
  pageableRegistration: {},
  isAddressCollapse: false,
  rsvpOnlineList: [],
  pageableOnlineRsvp: {},
  branchMaxCapacity: {},
  summaryRsvpVisitTime: [],
  loadingSummaryRsvpVisitTime: false
}

const admissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_ADDRESS_COLLAPSE':
      return {
        ...state,
        isAddressCollapse: !state.isAddressCollapse
      }
    case LIST_ADMISSION_REQUEST:
      return {
        ...state,
        loading: true,
        admissionList: [],
        pageable: {}
      }
    case LIST_ADMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        admissionList: action.payload,
        pageable: action.pageable
      }
    case LIST_ADMISSION_FAIL:
      return {
        ...state,
        loading: false,
        admissionList: [],
        pageable: {},
        error: action.payload
      }
    case LIST_ADMISSION_REGISTRATION_REQUEST:
      return {
        ...state,
        loadingRegistration: true
      }
    case LIST_ADMISSION_REGISTRATION_SUCCESS:
      return {
        ...state,
        loadingRegistration: false,
        registrationList: action.payload,
        pageableRegistration: action.pageable
      }
    case LIST_ADMISSION_REGISTRATION_FAIL:
      return {
        ...state,
        loadingRegistration: false,
        error: action.payload
      }
    case LIST_ADMISSION_RSVP_LIST_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ADMISSION_RSVP_LIST_SUCCESS:
      if (action.isRsvpOnline) {
        return {
          ...state,
          loading: false,
          rsvpOnlineList: action.payload,
          pageableOnlineRsvp: action.pageable
        }
      }
      return {
        ...state,
        loading: false,
        rsvpList: action.payload,
        pageable: action.pageable
      }
    case LIST_ADMISSION_RSVP_LIST_RESET:
      return {
        ...state,
        loading: false,
        rsvpList: [],
        rsvpOnlineList: [],
        pageable: action.pageable,
        pageableOnlineRsvp: action.pageable
      }
    case LIST_ADMISSION_RSVP_LIST_FAIL:
      if (action.isRsvpOnline) {
        return {
          ...state,
          loading: false,
          error: action.payload
        }
      }
      return {
        ...state,
        loading: false,
        rsvpList: action.dummy || [],
        error: action.payload
      }
    case CREATE_ADMISSION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_ADMISSION_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_ADMISSION_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_ADMISSION_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_ADMISSION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        rsvp: action.payload
      }
    case DETAIL_ADMISSION_FAIL:
      return {
        ...state,
        loadingDetail: false,
        rsvp: action.dummy,
        error: action.payload
      }
    case DETAIL_PROJECT_BY_PACKAGE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_PROJECT_BY_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        projectPackage: action.payload
      }
    case DETAIL_PROJECT_BY_PACKAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_ADMISSION_PACKAGE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ADMISSION_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        packageList: action.payload
      }
    case LIST_ADMISSION_PACKAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_ADMISSION_MS_PACKAGE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ADMISSION_MS_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        msPackageList: action.payload
      }
    case LIST_ADMISSION_MS_PACKAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_ADMISSION_MS_SERVICE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ADMISSION_MS_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        msServiceList: action.payload
      }
    case LIST_ADMISSION_MS_SERVICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_ADMISSION_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        additionalInfo: [],
        loadingAdditionalInfo: true
      }
    case LIST_ADMISSION_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingAdditionalInfo: false,
        additionalInfo: action.payload
      }
    case LIST_ADMISSION_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        loadingAdditionalInfo: false,
        additionalInfo: [],
        error: action.payload
      }
    case MEDICAL_INFO_SUMMARY_REQUEST:
      return {
        ...state,
        medicalInfoSummary: [],
        loadingMedicalInfo: true
      }
    case MEDICAL_INFO_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingMedicalInfo: false,
        medicalInfoSummary: action.payload
      }
    case MEDICAL_INFO_SUMMARY_FAIL:
      return {
        ...state,
        loadingMedicalInfo: false,
        medicalInfoSummary: [],
        error: action.payload
      }
    case MEDICAL_INFO_SUMMARY_OPTIONAL_REQUEST:
      return {
        ...state,
        loadingMedicalInfo: true
      }
    case MEDICAL_INFO_SUMMARY_OPTIONAL_SUCCESS:
      return {
        ...state,
        loadingMedicalInfo: false,
        medicalInfoOptionSummary: action.payload
      }
    case MEDICAL_INFO_SUMMARY_OPTIONAL_FAIL:
      return {
        ...state,
        loadingMedicalInfo: false,
        error: action.payload,
        medicalInfoOptionSummary: []
      }
    case DETAIL_ADMISSION_RSVP_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_ADMISSION_RSVP_SUCCESS:
      return {
        ...state,
        loading: false,
        rsvp: action.payload
      }
    case DETAIL_ADMISSION_RSVP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_ADMISSION_MR_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_ADMISSION_MR_SUCCESS:
      if (action.isMappingData) {
        return {
          ...state,
          loading: false,
          mrNumber: {
            ...state.rsvp,
            mcuProject: {},
            ...action.payload
          }
        }
      } else {
        return {
          ...state,
          loading: false,
          rsvp: {
            ...state.rsvp,
            mcuProject: {},
            ...action.payload
          }
        }
      }
    case DETAIL_ADMISSION_MR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case UPDATE_ADMISSION_REQUEST:
      return {
        ...state,
        loading: true,
        loadingEdit: true
      }
    case UPDATE_ADMISSION_SUCCESS:
      return {
        ...state,
        codeConfirm: action.payload?.code,
        loading: false,
        loadingEdit: false
      }
    case UPDATE_ADMISSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        loadingEdit: false
      }
    case DELETE_ADMISSION_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_ADMISSION_SUCCESS:
      return {
        ...state,
        loadingDelete: false
      }
    case DELETE_ADMISSION_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case RESET_ADMISSION_FORM:
      return {
        ...state,
        loadingUpdate: false,
        loadingDelete: false,
        loadingCreate: false,
        rsvpList: [],
        rsvp: {},
        mrNumberList: [],
        admission: {},
        mrNumber: {}
      }
    case DETAIL_PRINT_INVOICE_PATIENT_REQUEST:
      return {
        ...state,
        loadingDetailInvoice: true
      }
    case DETAIL_PRINT_INVOICE_PATIENT_SUCCESS:
      return {
        ...state,
        loadingDetailInvoice: false,
        detailPrintInvoice: action.payload,
        error: null
      }
    case DETAIL_PRINT_INVOICE_PATIENT_FAIL:
      return {
        ...state,
        loadingDetailInvoice: false,
        error: action.payload
      }
    case LOG_HISTORY_ADMISSION_REQUEST:
      return {
        ...state,
        loadingHistory: true,
        error: null
      }
    case LOG_HISTORY_ADMISSION_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        history: action.payload,
        error: null
      }
    case LOG_HISTORY_ADMISSION_FAIL:
      return {
        ...state,
        loadingHistory: false,
        error: action.payload,
        history: action.dummy
      }
    case LIST_PRINT_HISTORY_RESULT_REQUEST:
      return {
        ...state,
        loadingHisotryResult: true
      }
    case LIST_PRINT_HISTORY_RESULT_SUCCESS:
      return {
        ...state,
        loadingHisotryResult: false,
        error: null,
        historyResults: action.payload
      }
    case LIST_PRINT_HISTORY_RESULT_FAIL:
      return {
        ...state,
        loadingHisotryResult: false,
        error: action.payload,
        historyResults: action.dummy
      }
    case PRINT_HISTORY_RESULT_REQUEST:
      return {
        ...state,
        loadingPrintHistoryResult: true
      }
    case PRINT_HISTORY_RESULT_SUCCESS:
      return {
        ...state,
        loadingPrintHistoryResult: false,
        historyResult: action.payload,
        error: null
      }
    case PRINT_HISTORY_RESULT_FAIL:
      return {
        ...state,
        loadingPrintHistoryResult: false,
        error: action.payload
      }
    case IMPORT_ADMISSION_DATA_REQUEST:
      return {
        ...state,
        loadingImport: true
      }
    case IMPORT_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loadingImport: false,
        error: null
      }
    case IMPORT_ADMISSION_DATA_FAIL:
      return {
        ...state,
        loadingImport: false
      }
    case LIST_IMPORT_ADMISSION_DATA_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_IMPORT_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        importAdmissionDataList: action?.payload,
        pageable: action?.pageable,
        error: null
      }
    case LIST_IMPORT_ADMISSION_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action?.payload,
        importAdmissionDataList: []
      }
    case LIST_DETAIL_IMPORT_DATA_ADMISSION_REQUEST:
      return {
        ...state,
        loadingImport: true
      }
    case LIST_DETAIL_IMPORT_DATA_ADMISSION_SUCCESS:
      return {
        ...state,
        loadingImport: false,
        detailImportAdmissionDataList: action?.payload,
        pageable: action?.pageable,
        error: null
      }
    case LIST_DETAIL_IMPORT_DATA_ADMISSION_FAIL:
      return {
        ...state,
        loadingImport: false,
        error: action?.payload,
        detailImportAdmissionDataList: action?.dummy
      }
    case DETAIL_IMPORT_DATA_ADMISSION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_IMPORT_DATA_ADMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        importAdmissionData: action?.payload,
        error: null
      }
    case DETAIL_IMPORT_DATA_ADMISSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action?.payload,
        importAdmissionData: action?.dummy
      }
    case EXPORT_IMPORT_DATA_ADMISSION_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_IMPORT_DATA_ADMISSION_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_IMPORT_DATA_ADMISSION_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action?.payload
      }
    case RESET_DETAIL_PROJECT_BY_PACKAGE:
      return {
        ...state,
        projectPackage: {}
      }
    case GET_BRANCH_MAX_CAPACITY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case GET_BRANCH_MAX_CAPACITY_SUCCESS:
      return {
        ...state,
        loading: false,
        branchMaxCapacity: action.payload
      }
    case GET_BRANCH_MAX_CAPACITY_FAIL:
      return {
        ...state,
        loading: false,
        branchMaxCapacity: {},
        error: action.payload
      }
    case LIST_ADMISSION_ONLINE_RSVP_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ADMISSION_ONLINE_RSVP_SUCCESS:
      return {
        ...state,
        listOnlineRsvp: action.payload,
        pageable: action.pageable,
        loading: false,
        error: null
      }
    case LIST_ADMISSION_ONLINE_RSVP_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_SUMMARY_RSVP_VISIT_TIME_REQUEST:
      return {
        ...state,
        loadingSummaryRsvpVisitTime: true
      }
    case GET_SUMMARY_RSVP_VISIT_TIME_SUCCESS:
      return {
        ...state,
        summaryRsvpVisitTime: action.payload,
        loadingSummaryRsvpVisitTime: false,
        error: null
      }
    case GET_SUMMARY_RSVP_VISIT_TIME_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingSummaryRsvpVisitTime: false
      }
    case 'SUMMARY_STATION_ADMISSION_REQUEST':
      return {
        ...state,
        loadingStationSummary: true
      }
    case 'SUMMARY_STATION_ADMISSION_SUCCESS':
      return {
        ...state,
        summaryStation: action.payload,
        loadingStationSummary: false,
        error: null
      }
    case 'SUMMARY_STATION_ADMISSION_FAIL':
      return {
        ...state,
        error: action.payload,
        loadingStationSummary: false
      }
    case 'SUMMARY_SHIFTING_ADMISSION_REQUEST':
      return {
        ...state,
        loadingShiftingSummary: true
      }
    case 'SUMMARY_SHIFTING_ADMISSION_SUCCESS':
      return {
        ...state,
        summaryShifting: action.payload,
        loadingShiftingSummary: false,
        error: null
      }
    case 'SUMMARY_SHIFTING_ADMISSION_FAIL':
      return {
        ...state,
        error: action.payload,
        loadingShiftingSummary: false
      }
    case 'DETAIL_ADMISSION_GENERAL_CONSENT_REQUEST':
      return {
        ...state,
        loading: true
      }
    case 'DETAIL_ADMISSION_GENERAL_CONSENT_SUCCESS':
      return {
        ...state,
        loading: false,
        generalConsentDetail: action.payload
      }
    case 'DETAIL_ADMISSION_GENERAL_CONSENT_FAIL':
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default admissionReducer
